export const svgTransform = (size?: 'sm' | 'semismall' | 'md') => {
  const smScale = 18 / 24
  const semismallScale = 20 / 24

  switch (size) {
    case 'sm':
      return `scale(${smScale})`
    case 'semismall':
      return `scale(${semismallScale})`
    case 'md':
      return 'scale(1)'
    default:
      return 'scale(1)'
  }
}
